<template>
  <div id="app">
    <!-- Navbar start -->
    <NavBar></NavBar>
    <router-view/>
    <cookie-law theme="base">
      <div slot="message">
        Ce site web utilises des cookies pour améliorer votre epérence utilisateur. Pour plus d'informaion cliquez ici <router-link to="legal-notes">Click here</router-link>
      </div>
    </cookie-law>
  </div>
</template>

<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // font-family: 'Lato', sans-serif;
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

</style>

<script>
import NavBar from '@/components/NavBar.vue'
import CookieLaw from 'vue-cookie-law'
// import ImageSlider from '@/components/ImageSlider.vue'

export default {
  components: {
    NavBar,
    CookieLaw
    // ImageSlider
  }
}
</script>